
<template>



    <section>
          <b-container>
            <b-row align-v="center" class="row-grid">
              <b-col md="6" class="order-md-2">
                <b-img src="img/custom/heterotopie.png" fluid />
              </b-col>
              <b-col md="6" class="order-md-1">
                <div class="pr-md-5">
                    

                        <h1>
                            Share your art with us
                        </h1>
                        <p>
                            We are curious to see your vision for the book. Please share ten of your images that you would like to put in the
book or a link to your portfolio. Please share only files with open access. Unfortunately, we can't accept WeTransfer or request access to folders.
                        </p>
                        <dropzone-file-upload v-model="inputs.fileMultiple" multiple
                                        :options="sample_art_dz.options"
                                        :url="sample_art_dz.url" 
                                        v-on:complete="dz_complete" 
                                        v-on:success="dz_success" 
                                        v-on:addedfile="dz_added" 
                                        v-on:error="dz_error" 
                                        v-on:queuecomplete="dz_queuecomplete"
                                    ></dropzone-file-upload>
                                    
                                    <b-list-group v-for="(image, index) in currentPhotoBookImages" v-bind:key="index" class="list-group dz-preview dz-preview-multiple list-group-lg list-group-flush">

                                        <dz-list-group-item-noauth :url="null" :img="image" :id="image.id" :sfid="currentSnapWizard.id" :num="index" @image_deleted="image_deleted"></dz-list-group-item-noauth>

                                    </b-list-group>
                        <label>Link to your work</label>


                        <base-input prepend-icon="fas fa-globe" placeholder="link to a pdf of your work" v-model="currentSnapWizard.work_link" name="" rules="required|url"></base-input>
       



                </div>
              </b-col>
            </b-row>
          </b-container>
        </section>
    
    
       
    
    </template>
    
    
<script>
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'
import { Tooltip } from 'element-ui'
import TagsInput from '@/components/Inputs/TagsInput'
import DropzoneFileUpload from '@/components/Inputs/DropzoneFileUpload'
import DzListGroupItemNoauth from '../../../cscomponents/elements/DzListGroupItemNoauth';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';

export default {
    name: 'snap06',
    components: {
        TagsInput,
        [Tooltip.name]: Tooltip,
        DzListGroupItemNoauth,
        DropzoneFileUpload
    },
    data() {
        return {
            loading: false,
            
            sample_art_dz: {
                options: {
                    type: Object,
                    autoProcessQueue: true,
                    uploadMultiple: false,
                    parallelUploads: 1,
                    addRemoveLinks: false,
                    acceptedFiles: 'image/*,application/pdf',
                    maxFiles: 10,
                    maxFilesize: 1000,
                    disablePreviews: true,
                    timeout: 1800000,
                    paramName: "[snap_form][photo_book_images][temp_image]",
                    params: {
                        '[snap_form][photo_book_images][imagetype]': 'snap_form',
                        '[token]': '',
                    },
                },
                url: '',
            },
            inputs: {
                fileSingle: [],
                fileMultiple: []
            },
        }
    },




    methods: {
        onCancel: function () { },
        onProceed: function () { },
        allDataValidated: function () {
            console.log("ANZAHL BILDER:"+this.currentPhotoBookImages.length);
            console.log(this.currentPhotoBookImages.length > 9);
            console.log("WORK_LINK:"+this.currentPhotoBookImages.work_link);
            console.log("WORK_LINK result:"+(this.currentSnapWizard.work_link != "" || typeof this.currentSnapWizard.work_link !== "undefined"));
            if(this.currentPhotoBookImages.length > 9 || (this.currentSnapWizard.work_link != "" && typeof this.currentSnapWizard.work_link !== "undefined" )){
                this.$emit('showFooterNav');
                this.$emit('allowProceed');
                return true;
            }
            this.$emit('hideFooterNav');
            this.$emit('denyProceed');
            return false;
        },

        dzUrl(){
            
            return this.$image_host + '/api/v1/spa/snap_forms/'+this.currentSnapWizard.id+'/photo_book_image';
        },
        buildUrl(image){
            console.log(image)
            let ht = this.$image_host+image.image.medium.url;
            return ht
        },
        dz_added(data){
            console.log("ADDED"+data);
        },
        // dropzone part
        dz_complete(data){
            this.allDataValidated();
        },
        image_deleted(imgid){
            this.allDataValidated();
        },
        dz_success(data){
            console.log(data.xhr.response);
            this.currentPhotoBookImages.push(JSON.parse(data.xhr.response));
            this.allDataValidated();
        },
        dz_error(data){
            swal.fire({
                title: 'Please check requirements:',
                text: this.build_error_text(data.xhr.response),
                timer: 5000,
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-warning',
                icon: 'warning'
            });
        },
        dz_queuecomplete(data){
            console.log("QUEUECOMPLETE");
            //console.log(data);
            this.allDataValidated();
        },

    },
    computed: {
        ...mapGetters({
            currentSettings: 'currentSettings',
            currentSnapWizard: 'currentSnapWizard',
            currentSnapWizardStep: 'currentSnapWizardStep',
            currentPhotoBookImages: 'currentPhotoBookImages',
        }),
        show_images_hint() {
            if(this.currentSnapWizard.images_ready == 1){
                return true;
            }
            else{
                return false;
            }
        },
    },
    watch: {
        currentSnapWizard: {
            handler:function (newItem) {
                //console.log("DEEPWATCH");//this.doSomethingWith(newItem);
                //this.currentPhotoBook.keywords = this.currentPhotoBook.keywords.split(',');
                this.allDataValidated();
            },
            deep: true
        },
        currentPhotoBookImages(newValue, oldValue) {
            console.log('queryParameter currentPhotoBookImages changed from: ' + oldValue + ' -> ' + newValue);
            this.allDataValidated();
        },
    },
    mounted() {
        this.$emit('denyProceed');
        this.$emit('hideFooterNav');
        this.allDataValidated();
        this.sample_art_dz.url = this.dzUrl();
        this.sample_art_dz.params = 
        {
                        '[snap_form][photo_book_images][imagetype]': 'snap_form',
                        '[token]': this.currentSnapWizard.token,
                    }
        this.$store.dispatch('fetchSnapFormImages', { id: this.currentSnapWizard.id, imagetype: "snap_form" });
    }
};
</script>


<style>
        .dropzone {
            /*
            border: dashed 4px #ddd !important ;
            background-color: #f2f6fc;
            */
            width: 100%;
            border-radius: 15px;
        }
    
        .dropzone .dropzone-container {
            padding: 2rem 0;
            width: 100%;
            height: 100%;
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            color: #8c96a8;
            z-index: 20;
        }
    
        .dropzone .file-input {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            opacity: 0;
            visibility: hidden;
            cursor: pointer;
        }

        .file-icon{
            font-size: 60px;
        }
        .hr-sect {
            display: flex;
            flex-basis: 100%;
            align-items: center;
            margin: 8px 0px;
        }
        .hr-sect:before,
        .hr-sect:after {
            content: "";
            flex-grow: 1;
            background: #ddd;
            height: 1px;
            font-size: 0px;
            line-height: 0px;
            margin: 0px 8px;
        }

        .dz-message{
            z-index: 999;
            padding: 5rem 1rem;
            cursor: pointer;
            transition: all .15s ease;
            text-align: center;
            color: #8898aa;
            border: 1px dashed #dee2e6;
            border-radius: .375rem;
            background-color: #fff;
            order: -1;
        }
        
    </style>
    